// import React, { useState } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Typography,
//   Box,
// } from "@mui/material";

// interface AboutUsDialogProps {
//   openAboutUs: boolean;
//   onClose: () => void;
// }

// const AboutUsDialog: React.FC<AboutUsDialogProps> = ({ openAboutUs, onClose }) => {
//   return (
//     <Dialog
//       open={openAboutUs}
//       onClose={onClose}
//       fullWidth
//       maxWidth="sm"
//       PaperProps={{
//         sx: {
//           borderRadius: "20px",
//           boxShadow: "0 8px 24px rgba(0,0,0,0.2)"
//         }
//       }}
//     >
//       {/* Heading */}
//       <DialogTitle sx={{ fontWeight: "bold", textAlign: "center" }}>
//         About Us
//       </DialogTitle>

//       {/* Body */}
//       <DialogContent dividers>
//         <Typography paragraph>
//           Indeeclips - India ka Apna Video Platform!
//         </Typography>
//         <Typography paragraph>
//           Built for Bharat, inspired by creators, Indeeclips is more than just a video-sharing app -
//           it's a movement. From full-length content to viral clips, Indeeclips gives every creator
//           the power to shine, grow, and build their own digital identity.
//         </Typography>
//         <Typography paragraph>
//           Ab koi algorithm ka slave nahi - tu jo banaye, wahi dikhega.
//           Apne content ka asli malik ban.
//         </Typography>
//         <Typography paragraph>
//           Jo Banaya, Wo Sab Yahan - Tere Videos, Tera Style!
//         </Typography>

//         <Typography paragraph>
//           Why Indeeclips?
//         </Typography>
//         <ul style={{ margin: 0, paddingLeft: "16px" }}>
//           <li>Upload full videos & short clips with ultra-fast processing</li>
//           <li>Personalized video suggestions powered by intelligent AI</li>
//           <li>Build your audience, your way</li>
//           <li>Monetization tools - Coming Soon (kyunki creator deserve karta hai reward)</li>
//           <li>Clean, creator-first interface - 100% Made in India</li>
//           <li>No distractions, no compromises - sirf content aur creativity</li>
//         </ul>

//         <Typography paragraph>
//           India's answer to global video platforms is here. No filters. No boundaries.
//           Just pure, raw, desi creativity.
//         </Typography>

//         <Typography paragraph>
//           Come, be a part of the revolution. <b>Indeeclips - Jahan Creator Banta Hai Star!</b>
//         </Typography>
//       </DialogContent>

//       {/* Footer */}
//       <DialogActions sx={{ justifyContent: "flex-end" }}>
//         <Button
//           variant="text"
//           color="primary"
//           onClick={onClose}
//         >
//           OK
//         </Button>
//       </DialogActions>

//     </Dialog>
//   );
// };

// export default AboutUsDialog;

import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from "@mui/material";
import { useTranslation } from "react-i18next";

interface AboutUsDialogProps {
  openAboutUs: boolean;
  onClose: () => void;
}

const AboutUsDialog: React.FC<AboutUsDialogProps> = ({ openAboutUs, onClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={openAboutUs}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: "20px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.2)"
        }
      }}
    >
      {/* Heading */}
      <DialogTitle sx={{ fontWeight: "bold", textAlign: "center" }}>
        {t("aboutUs.title")}
      </DialogTitle>

      {/* Body */}
      <DialogContent dividers>
        <Typography paragraph>{t("aboutUs.intro1")}</Typography>
        <Typography paragraph>{t("aboutUs.intro2")}</Typography>
        <Typography paragraph>{t("aboutUs.intro3")}</Typography>
        <Typography paragraph>{t("aboutUs.intro4")}</Typography>

        <Typography paragraph>{t("aboutUs.why")}</Typography>
        <ul style={{ margin: 0, paddingLeft: "16px" }}>
          {(Array.isArray(t("aboutUs.points", { returnObjects: true }))
            ? (t("aboutUs.points", { returnObjects: true }) as string[])
            : []
          ).map((point: string, idx: number) => (
            <li key={idx}>{point}</li>
          ))}
        </ul>

        <Typography paragraph>{t("aboutUs.closing1")}</Typography>
        <Typography paragraph>
          <b>{t("aboutUs.closing2")}</b>
        </Typography>
      </DialogContent>

      {/* Footer */}
      <DialogActions sx={{ justifyContent: "flex-end" }}>
        <Button variant="text" color="primary" onClick={onClose}>
          {t("aboutUs.ok")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AboutUsDialog;
